// MobilePortfolios — vista portafogli ottimizzata mobile
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { FolderOpen, Loader2, Inbox, ChevronRight } from "lucide-react";
import MobileShell from "@/components/mobile/MobileShell";
import { api } from "@/lib/api";

export default function MobilePortfolios() {
  const [data, setData] = useState({ items: [], unassigned_count: 0, total: 0 });
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/portfolios/groups");
        setData(r.data);
      } catch (e) {
        console.error("MobilePortfolios: errore caricamento", e);
      } finally { setLoading(false); }
    })();
  }, []);
  const total = (data.total || 0) + (data.unassigned_count || 0);
  return (
    <MobileShell title="Portafogli" subtitle={`${data.items?.length || 0} portafogli · ${total.toLocaleString("it-IT")} clienti`} back>
      {loading ? (
        <div className="flex justify-center py-16 text-slate-400"><Loader2 className="w-6 h-6 animate-spin" /></div>
      ) : (
        <div className="space-y-2" data-testid="mport-list">
          <Link to="/m/clienti" className="bg-white p-3 flex items-center gap-3 active:bg-[#F4F6FA]" style={{ border: "1px solid #E8ECF2", borderRadius: 12, boxShadow: "0 1px 3px rgba(10,25,47,0.04)" }}>
            <div className="w-10 h-10 rounded-[10px] bg-[#0A192F] text-white flex items-center justify-center shrink-0">
              <Inbox className="w-5 h-5" />
            </div>
            <div className="flex-1">
              <div className="text-sm font-medium text-slate-900">Tutti i clienti</div>
              <div className="text-[11px] text-slate-500">{total.toLocaleString("it-IT")} totali</div>
            </div>
            <ChevronRight className="w-4 h-4 text-slate-300" />
          </Link>
          {data.items?.filter((p) => !p.archived || p.client_count > 0).map((p) => (
            <Link key={p.id} to={`/m/clienti?portfolio=${p.id}`} data-testid={`mport-${p.id}`}
                  className="bg-white p-3 flex items-center gap-3 active:bg-[#F4F6FA]" style={{ border: "1px solid #E8ECF2", borderRadius: 12, boxShadow: "0 1px 3px rgba(10,25,47,0.04)" }}>
              <div className="w-10 h-10 rounded-[10px] flex items-center justify-center shrink-0 text-white"
                   style={{ background: p.color || "#94a3b8" }}>
                <FolderOpen className="w-5 h-5" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-medium text-slate-900 truncate">{p.name}</div>
                <div className="text-[11px] text-slate-500 uppercase tracking-wider">{p.source || "manual"}</div>
              </div>
              <div className="text-right">
                <div className="text-base font-serif tabular-nums" style={{ color: p.color || "#0A192F" }}>{p.client_count}</div>
              </div>
              <ChevronRight className="w-4 h-4 text-slate-300" />
            </Link>
          ))}
          {data.unassigned_count > 0 && (
            <Link to="/m/clienti?portfolio=__none__"
                  className="bg-white p-3 flex items-center gap-3 active:bg-[#F4F6FA]" style={{ border: "1px solid #E8ECF2", borderRadius: 12, boxShadow: "0 1px 3px rgba(10,25,47,0.04)" }}>
              <div className="w-10 h-10 rounded-[10px] bg-slate-300 text-white flex items-center justify-center shrink-0">
                <FolderOpen className="w-5 h-5" />
              </div>
              <div className="flex-1">
                <div className="text-sm font-medium text-slate-900">Senza portafoglio</div>
                <div className="text-[11px] text-slate-500">Clienti non assegnati</div>
              </div>
              <div className="text-base font-serif text-slate-500 tabular-nums">{data.unassigned_count}</div>
              <ChevronRight className="w-4 h-4 text-slate-300" />
            </Link>
          )}
        </div>
      )}
    </MobileShell>
  );
}
